import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, Icon, Pagination, Avatar, notification, Empty, Radio, Form, Input, message, Select } from 'antd';
import {discountrequestAddDataSchema, searchData, viprequestAddDataSchema} from '../../schema/discount-request';
import { UndoOutlined, CloseOutlined, UserOutlined } from '@ant-design/icons';
import moment from 'moment';
import Select2 from '../../components/FormComponent/select2';
import Inputlayer from '../../components/FormComponent/Input';
import RadioButtonLayer from '../../components/FormComponent/Input/radioButton';
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';
import userTrackService from './../../services/usertrack-service';
import {formDataSchema} from '../../schema/bill-tacking';
import DateRange from '../../components/FormComponent/DateRange';
import { CSVLink } from "react-csv";
const { getPatientTrackbillInfo, homepage, insertPatientDiscountRequest }=networkList

let i = 0;
class TagVip extends Component {
    csvLink = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loadding: false,
      add_discount_form: false,
      selectedOption: '',
      formData: [],
      'thead': [],
      tbody: [],
      remarks: null,
      patient_willing: 'NO',
      ip_no: null,
      umr_no:null,
      activePage:1,
      dateTo: moment().format('YYYY-MM-DD'),
      dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
      total_items:0,
      page_length:30,
      downloadStatus:0,
      'downloadtbody': [],
      filtereData:[],
      saveClicked: false,
      btnloading:false,
      patientName: '',
      patientPhone: '',
    };
  }


  componentDidMount() {
    //this.getTokensForTG();
        //this.interval = setInterval(() => { this.getTokensForTG() }, 20000);
        this.setState((state) => ({ 'loadding': true, 'formData': viprequestAddDataSchema['feilds'], 'filtereData': searchData['feilds'] }), () => {
            let { formData, filtereData } = this.state
            filtereData.map((d, i) => {
                filtereData[i]['value'] = null;
            })
            formData.map((form, key) => {
                formData[key]['value'] = null;
                if (form['name'] === 'service_type_admission' || form['name'] === 'vip-status' || form['name'] === 'patient_list') {
                    formData[key]['disable'] = true;
                    delete formData[key]['text']
                }

            })
            this.setState((state) => ({ 'loadding': false, 'formData': formData, 'filtereData': filtereData }));
            this.loadPage()
        })
   
    let discountrequestAddformDataSchema = Object.assign({}, viprequestAddDataSchema);
    discountrequestAddformDataSchema['feilds'].map((feild, key) => {
        if (feild.name === 'ip') {
            discountrequestAddformDataSchema['feilds'][key]['value'] = [];
            discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
            discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
            discountrequestAddformDataSchema['feilds'][key]['text'] = 'Add Ip';
        } 
        
        else if (feild.name === 'patient_list') {
            discountrequestAddformDataSchema['feilds'][key]['value'] = [];
            discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
            discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
            discountrequestAddformDataSchema['feilds'][key]['text'] = 'Please Select Patient Name';
        } 
        else if (feild.name === 'vip_status') {
            discountrequestAddformDataSchema['feilds'][key]['value'] = [];
            discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
            discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
            discountrequestAddformDataSchema['feilds'][key]['text'] = 'Tag Status';
        } 
       
    })
    this.setState({ 'discountrequestaddformData': discountrequestAddformDataSchema['feilds']});
}

loadPage = () => {
    try {
        let This = this;
        let userData = localStorage.getItem('user_data');
        const { getEstimateVarianceWorklist } = networkList;
        let { activePage, doctor_id, department_name, payer_type,  nurse_station_code, ward_type,variance } = this.state;
        if (userData !== undefined && userData !== null && userData !== '') {
            userData = JSON.parse(userData);
        }
        let tableHead = [
           {
            'key': 'patient_name',
            'text': 'Patient Name' 
        },
        {
            'key': 'ip_no',
            'text': 'IP number'  
        },
        {
            'key': 'umr_no',
            'text': 'UMR number'  
        },
       
        {
            'key': 'mobile_number',
            'text': 'Phone number'  
        },
        {
            'key': 'vip_status',
            'text': 'VIP Status'
        },
        {
            'key': 'comment',
            'text': 'Remarks' 
        },
        {
            'key': 'created_by',
            'text': 'Requested By' 
        },
        {
            'key': 'created_date',
            'text': 'Requested At'
        },
        ];
      
        this.setState((state) => ({ showFilter: true, tableTitle: 'Estimate Variance', thead: tableHead, filename: 'vip-tag.csv', loadding: true, download_btn: true, select2: false }), () => {
            postService('getPatientVipStatus', 'POST',
               { "data": {
                    "search_key": this.state.search ? this.state.search : "",
                    "export": 0, //1 for download excel
                    "page_no": activePage,
                    "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                    "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                }}
            ).then(res => {
                if (res.status) {

                    this.setState((state) => ({ 
                        total_items: res.total_items,
                         tbody: res.data , loadding: false,responseData:res.data }));
                // enable downloadbtn after 2sec
                setTimeout(function () {
                    This.setState((state) => ({ downloadStatus: 1 }))
                    }, 2000);
                } else {
                    if (res === 401) {

                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again.",
                        });
                    }
                }
            });
        });

    } catch (error) {
        console.log(error);
    }
}

  addDiscountForm = () => {
    this.setState({'add_discount_form': true})
  }

  discountAddHandleCancel = e => {
    let discountrequestAddformDataSchema = Object.assign({}, viprequestAddDataSchema);
                discountrequestAddformDataSchema['feilds'].map((feild, key) => {
                    if (feild.name === 'mobile') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Select Unit';
                    } 
                    
                    else if (feild.name === 'umr') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Select Department';
                    }
                    else if (feild.name === 'ipnumber') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Enter IP Number';
                    }
                    else if (feild.name === 'patient_list') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = '';
                    } 
                    else if (feild.name === 'vip_status') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Tag Status';
                    }
                    else if (feild.name === 'vip_status') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Tag Status';
                    }    
                })
    this.setState({ 'add_discount_form': false, 'discountrequestaddformData': discountrequestAddformDataSchema['feilds'],'patient_willing': 'NO', remarks: null});
    //this.setState({ 'add_discount_form': false, 'patient_willing': 'NO' });
}  

handleOptionChange = (event) => {
    this.setState({
      selectedOption: event.target.value,
    });
  };

  remarks(event) {
    let value = event.target.value;
    console.log('RemarksIsuue', value)
    this.setState((state) => ({ 'remarks': value ? value : null }));
    }

    addDiscountRequest = () => {
    const { saveFCChecklist, insertMasterNmeList, insertPatientDiscountRequest } = networkList;
    try {
        const { discountrequestaddformData, remarks, patient_willing, ip_no, umr_no,filtereData} = this.state;
        // console.log('TEstingDiscount', this.state.filtereData[0].value);
        console.log('TEstingDiscount', this.state);
        if (!this.state.discountrequestaddformData[0].value && !this.state.discountrequestaddformData[1].value && !this.state.discountrequestaddformData[2].value) {
            Modal.error({
                title: 'Error',
                content: 'Phone Number or IP or UMR is required ',
            });
            return;
        }
        else if (!this.state.discountrequestaddformData[5].value) {
            Modal.error({
                title: 'Error',
                content: 'vip_status is required',
            });
            return;
        }
        // else if (!remarks) {
        //     Modal.error({
        //         title: 'Error',
        //         content: 'Please Add Comments',
        //     });
        //     return;
        // }
        var formFeilds = discountrequestaddformData;
        let ipnumber = filtereData[5].value;
        let umrnumber = filtereData[2].value;
        let userData = localStorage.getItem('user_data');
        userData = JSON.parse(userData);
        let kimsUserId = null;
        let kimsUserName = null;
        let kimsUserUnit = null;
        if (userData) {
            kimsUserId = userData.kims_userid;
            kimsUserName = userData.username;
            kimsUserUnit = userData.unitid;
            console.log('kims_userid:', kimsUserId);
        }
        this.setState((state) => ({ btnloading: true }), () => {
            postService('UpdatePatientVipStatus', 'POST', {
                "data": {
                    "ip_number": ipnumber,
                    "umr_no": umrnumber,
                    "vip_status": formFeilds[5]["value"] ? formFeilds[5]["value"] : null,
                    "remarks": remarks,
                    "user_name": kimsUserName,
                    "user_id": kimsUserId,
                    "unit_id": kimsUserUnit,
                    "patient_name": this.state.filtereData[0].value,
                    "mobile_number" : this.state.filtereData[1].value,
                }
            }).then(res => {
                console.log('DisRes', res);
                if (res.status) {
                    console.log('1@', res.data);
                    if (res.data === 1) {
                        console.log('DisRes2', res.data);
                        console.log('ResData', res.data);
                        this.setState((state) => ({ btnloading: false, add_discount_form: false}));
                        this.getconfigurations();
                        this.loadPage(); 
                        Modal.warning({
                            title: 'Warning',
                            content: res.message ? res.message : 'Discount request raised',
                        });
                       
                    }
                    else {
                        console.log('DisRe3', res.data);
                        this.setState((state) => ({ btnloading: false, add_discount_form: false}));
                        //this.getconfigurations();
                        this.loadPage(); 
                        Modal.success({
                            title: 'Success',
                            content: res.message ? res.message : 'Discount request raised',
                        });
                        //this.getNmeList();
                    }
                
                }
                 else {
                    console.log('DisRe4', res.data);
                    this.setState((state) => ({ btnloading: false}));
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : "Please Insert IP or UMR or Comment",
                    });
                }
                let discountrequestAddformDataSchema = Object.assign({}, viprequestAddDataSchema);
                discountrequestAddformDataSchema['feilds'].map((feild, key) => {
                    if (feild.name === 'mobile') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Select Unit';
                    } 
                    
                    else if (feild.name === 'umr') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Select Department';
                    }
                    else if (feild.name === 'ipnumber') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Enter IP Number';
                    }
                    else if (feild.name === 'patient_list') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = '';
                    }  
                    else if (feild.name === 'vip_status') {
                        discountrequestAddformDataSchema['feilds'][key]['value'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                        discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Tag Status';
                    }    
                })
                this.setState({ 'discountrequestaddformData': discountrequestAddformDataSchema['feilds'], remarks: null, is_patient_dead: 'NO'});
            })
        
        });
    } catch (error) {
        Modal.error({
            title: 'Failure',
            content: "Oops, something went wrong... Please try again.",
        });
        console.log('discountrequestAddformDataSchema', this.state)
    }
}


handleChangeRemarks=(event)=>{
    let value = event.target.value;
    console.log('RemarksValue', value);
    let discountrequestAddformDataSchema = Object.assign({}, viprequestAddDataSchema);
    discountrequestAddformDataSchema['feilds'].map((feild, key) => {

    })
    this.setState({ 'nmelistformData': discountrequestAddformDataSchema['feilds'], remarks:value });
}

handleCheckboxChange = () => {
    // Toggle the value of the checkbox state
    this.setState({ patient_willing: 'YES' }, () => {
      console.log('StateValue', this.state);
    });
  };


  handleChange(ele, event) {
    if (ele) {
    }
}

formonChange(evnt) {
    console.clear();
    let formData = this.state.formData;
    let filtereData = this.state.filtereData;
    let patient_list_val = false;
    let {pat_address, marital_status, is_icu, vip_status}=this.state;
    console.log('EVE::::::',formData, filtereData, this.state);
    // let patientType = null;
    // let payment_type = null
    // let billStatus = null;
    // let billnumber = null;
    // let { checkPatientbill } = networkList;
    formData.map((data, key) => {

        if (data['name'] === evnt.name) {
            formData[key]['value'] = evnt.value;
            formData[key]['valid'] = true;
        }
        if (data['name'] === 'patient_list' && data['value'] !== null && data['value'] !== '') {
            patient_list_val = true;
        }
        if (patient_list_val) {
            if (data['name'] === 'service_type_admission') {
                formData[key]['disable'] = false;
                //formData[key]['value'] = null;
                // delete formData[key]['text'];
            }
            if (data['name'] === 'doctor') {
                formData[key]['disable'] = false;
                //formData[key]['value'] = null;
                // delete formData[key]['text'];

            }
            
        }

        if (!patient_list_val) {
            if (data['name'] === 'service_type_admission') {
                formData[key]['disable'] = true;
                formData[key]['value'] = null;
                delete formData[key]['text'];
            }
            if (data['name'] === 'doctor') {
                formData[key]['disable'] = true;
                formData[key]['value'] = null;
                delete formData[key]['text'];
            }
            if (data['name'] === 'counsellor') {
                formData[key]['disable'] = true;
                formData[key]['value'] = null;
                delete formData[key]['text']; 
            }
        }

        // if (data['name'] === 'patient_type') {
        //     patientType = data['value'];
        // }
        // if (data['name'] === 'payment_status') {
        //     payment_type = data['value'];
        // }

        // if (data['name'] === evnt.name && evnt.name === 'bill_no') {

        //     data['errors'] = [];
        //     billnumber = evnt.value;
        //     let postData = { "data": { "patientType": patientType, "billnumber": billnumber } }
        //     postService(checkPatientbill, 'POST', postData).then(res => {
        //         if (res) {
        //             console.log("billing checking.....");
        //             console.log(res);
        //             if (res.status) {
        //                 if (res.data === 'valid') {
        //                     this.setState((state) => ({ billStatus: true }), () => {
        //                         this.validateForm(formData);
        //                     });
        //                     data['valid'] = true;
        //                 } else {
        //                     this.setState((state) => ({ billStatus: false }), () => {
        //                         this.validateForm(formData);
        //                     });
        //                     data['valid'] = false;
        //                 }

        //             }
        //         } else {
        //             this.setState((state) => ({ billStatus: false }), () => {
        //                 this.validateForm(formData);
        //             });
        //             data['valid'] = false;
        //         }
        //     });

        // }
        // return data;
    });
    if (evnt.name === 'patient_list') {
        let patient_details = '{' + evnt.value + '}';
        let patient = JSON.parse(patient_details);
        console.log('patient:',patient);
        filtereData.map((d, i) => {
            console.log('DD::::::', d);
            if (d.name === 'name') {
                d['value'] = patient.NAME;
                d['disable'] = true;
            }
            if (d.name === 'umr_number') {
                d['value'] = patient.UMR;
                d['disable'] = true;
            }
            if (d.name === 'phonenumber') {
                d['value'] = patient.MOBILENO;
                d['disable'] = true;
            }
            if (d.name === 'gender') {
                if (patient.GENDER == 'M' || patient.GENDER == 'Male') {
                    d['value'] = 'Male';
                } else {
                    d['value'] = patient.GENDER;
                }

                d['disable'] = true;
            }
            if (d.name === 'age') {
                d['value'] = patient.AGE;
                d['disable'] = true;
            }
            if (d.name === 'ip') {
                d['value'] = patient.IP;
                d['disable'] = true;
            }
            if (d.name === 'marital_status') {
                d['value'] = marital_status;
                d['disable'] = true;
            }
            if (d.name === 'pat_address') {
                d['value'] = pat_address;
                d['disable'] = true;
            }
            if (d.name === 'is_icu') {
                d['value'] = is_icu;
                d['disable'] = true;
            }
            if (d.name === 'vip_status') {
                d['value'] = vip_status;
                d['disable'] = true;
            }
            return d;
        })
        console.log('FILEDATA:::', filtereData);
        this.setState((state) => ({ 'filtereData': filtereData }));
    }
    if(evnt.name==="service_type_admission"){
        formData.map((data, key) => {
            if(evnt.value===5){
                if (data['name'] === 'doctor') {
                    formData[key]['className']='col-4';
                }
                if (data['name'] === 'counsellor') {
                    localStorage.setItem('privilege_id', evnt.value);
                    formData[key]['visible'] = true;
                    formData[key]['disable'] = false;
                }
            }
            else{
                if (data['name'] === 'doctor') {
                    formData[key]['className']='col-8';
                }
                if (data['name'] === 'counsellor') {
                formData[key]['visible'] = false;
                formData[key]['disable'] = false;
                }
            }
        })
    }





    this.setState((state) => ({ formData: formData }), () => {
        this.validateForm(formData);
    });

}

SearchEvent() {
    this.setState((state) => ({ 'loadding': true }));
    let formData = this.state.formData;
    console.log('TABLE123', formData)
    let filtereData = this.state.filtereData;
    let data = [];
    if (formData !== undefined) {
        formData.map((feild, key) => {
            formData[key]['error'] = [];
            if (feild.name === 'umr' && feild.value !== null && feild.value !== '') {
                data.push(true);
            }
            if (feild.name === 'mobile' && feild.value !== null && feild.value !== '') {
                var regex = /^\d{10}$/g;
                let value = parseInt(feild.value);
                console.log(regex.test(value), regex.test(feild.value), feild.value, value)
                if (value !== null && value.length > 0 && regex.test(value) === false) {
                    data.push(false);
                } else {
                    if (regex.test(value) === true) {
                        data.push(true);
                    }
                }

            }
            if (feild.name === 'ipnumber' && feild.value !== null && feild.value !== '') {
                data.push(true);
            }
        })


        if (!data.includes(false) && data.includes(true) && data.length >= 1) {
            let payload = { "patientidentity": null, "MOBILENO": null, "patienttype": "OP", "ADMISSIONNO": "", "UMRNO": "" };
            formData.map((fmdata, fmkey) => {

                if (fmdata.name === 'umr' && fmdata.value !== null) {
                    payload["UMRNO"] = fmdata.value;
                    // payload = { "patientidentity": fmdata.value, "mobileno": "", "patienttype": "OP" }
                }
                if (fmdata.name === 'mobile' && fmdata.value !== null) {
                    payload["MOBILENO"] = fmdata.value;
                    // payload = { "patientidentity": null, "mobileno": fmdata.value, "patienttype": "OP" }
                }
                if (fmdata.name === 'ipnumber' && fmdata.value !== null) {
                    payload["ADMISSIONNO"] = fmdata.value;
                    payload["patienttype"] = "IP";
                    // payload = { "patientidentity": fmdata.value, "mobileno": "", "patienttype": "IP" }

                }
            });
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            payload["unit_id"] = userData ? userData['unitid'] ? userData['unitid'] : null : null;
            let { getPatientDetailsForQueue } = networkList;
            postService(getPatientDetailsForQueue, 'POST', { 'data': payload }).then(res => {
                if (res.status) {

                    if (res.data && Array.isArray(res.data) && res.data.length !== 0) {
                         res.data=res.data.filter((x)=>x.ISOSP!=='YES');
                         console.log('PatientData', res.data, res['data'][0]['ISVIP']);
                         let isVip = res.data[0]['ISVIP'] === 'Y';
                        // this.setState({'marital_status': res['data'][0]['MARITALSTATUS'], 'pat_address': res['data'][0]['PAT_ADDRESS'], 'is_icu': (res['data'][0]['IS_ICCU'] && res['data'][0]['IS_ICCU'] == 'YES') ? 1 : 0,wardname:res['data'][0]['WARDNAME']?res['data'][0]['WARDNAME']:null,floor:res['data'][0]['FLOOR']?res['data'][0]['FLOOR']:null,block:res['data'][0]['BLOCK']?res['data'][0]['BLOCK']:null,nursestation_name:res['data'][0]['NURSESTATION_NAME']?res['data'][0]['NURSESTATION_NAME']:null, ip_no: res['data'][0]['ADMISSIONNO'] ? res['data'][0]['ADMISSIONNO'] : null, umr_no: res['data'][0]['UMRNO'] ? res['data'][0]['UMRNO'] : null})
                        this.setState({'marital_status': res['data'][0]['MARITALSTATUS'], 'pat_address': res['data'][0]['PAT_ADDRESS'], 'is_icu': (res['data'][0]['IS_ICCU'] && res['data'][0]['IS_ICCU'] == 'YES') ? 1 : 0,wardname:res['data'][0]['WARDNAME']?res['data'][0]['WARDNAME']:null,floor:res['data'][0]['FLOOR']?res['data'][0]['FLOOR']:null,block:res['data'][0]['BLOCK']?res['data'][0]['BLOCK']:null,nursestation_name:res['data'][0]['NURSESTATION_NAME']?res['data'][0]['NURSESTATION_NAME']:null, 'vip_status': res['data'][0]['ISVIP']})
                        // console.log('resget:',res)
                        formData.map((fmdata, fmkey) => {
                            if (fmdata.name === 'patient_list') {
                                formData[fmkey]['disable'] = false;
                                formData[fmkey]['value'] = null;
                                delete formData[fmkey]['text'];
                                filtereData.map((d, i) => {
                                    d['value'] = null;
                                    return d;
                                })
                                this.setState((state) => ({ 'filtereData': filtereData }));
                            }                               

                            if (fmdata['name'] === 'service_type_admission') {
                                formData[fmkey]['disable'] = false;
                                formData[fmkey]['value'] = null;
                                delete formData[fmkey]['text'];
                            }
                            if (fmdata['name'] === 'doctor') {
                                formData[fmkey]['disable'] = false;
                                formData[fmkey]['className']='col-8';
                                formData[fmkey]['value'] = null;
                                delete formData[fmkey]['text'];
                            }
                            if (fmdata['name'] === 'counsellor') {
                                formData[fmkey]['disable'] = false;
                                formData[fmkey]['visible'] = false;
                                formData[fmkey]['value'] = null;
                                delete formData[fmkey]['text'];
                            }

                        });
                            let discountrequestAddformDataSchema = Object.assign({}, viprequestAddDataSchema);
                            discountrequestAddformDataSchema['feilds'].map((feild, key) => {
                                if (feild.name === 'vip_status') {
                                    if (isVip) {
                                        discountrequestAddformDataSchema['feilds'][key]['value'] = 'Y';
                                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Yes';
                                    } else {
                                        discountrequestAddformDataSchema['feilds'][key]['value'] = '';
                                        discountrequestAddformDataSchema['feilds'][key]['text'] = 'Tag Status';
                                    }
                                    discountrequestAddformDataSchema['feilds'][key]['valid'] = false;
                                    discountrequestAddformDataSchema['feilds'][key]['errors'] = [];
                                }
                            });
                    } else {
                        Modal.info({
                            title: 'Message',
                            content: 'No record found with the given details',

                        });
                        this.setState({'marital_status': null, 'pat_address': null, 'is_icu': null})
                        formData.map((fmdata, fmkey) => {
                            if (fmdata.name === 'patient_list') {
                                formData[fmkey]['disable'] = true;  
                                formData[fmkey]['value'] = null;
                                delete formData[fmkey]['text']
                                filtereData.map((d, i) => {
                                    d['value'] = null;
                                    return d;
                                })
                                this.setState((state) => ({ 'filtereData': filtereData }));
                            }

                            if (fmdata['name'] === 'service_type_admission') {
                                formData[fmkey]['disable'] = true;
                                formData[fmkey]['value'] = null;
                                delete formData[fmkey]['text'];
                            }
                            if (fmdata['name'] === 'doctor') {
                                formData[fmkey]['disable'] = true;
                                formData[fmkey]['className']='col-8';
                                formData[fmkey]['value'] = null;
                                delete formData[fmkey]['text'];
                            }
                            if (fmdata['name'] === 'counsellor') {
                                formData[fmkey]['disable'] = false;
                                formData[fmkey]['visible'] = false;
                                formData[fmkey]['value'] = null;
                                delete formData[fmkey]['text'];
                            }

                        })
                    }
                    if (res['data'] && res['data'].length > 0) {
                        this.setState({ 'payer_type': res['data'][0]['PATIENTTYPE'] ? res['data'][0]['PATIENTTYPE'] : null })
                    } else {
                        this.setState({ 'payer_type': null })
                    }
                    console.log('Ressssss:::', res.data, formData);
                    this.setState((state) => ({ 'loadding': false, 'searchPatient': res.data, 'formData': formData }))

                } else {
                    this.setState((state) => ({ 'loadding': false }));
                }
            })
            // this.setState((state) => ({ formData: formData }), () => {
            //     this.validateForm(formData);
            // });
        } else {
            this.setState((state) => ({ 'loadding': false }));
            let modalShow = true;
            formData.map((fmdata, fmkey) => {
                if (fmdata.name === 'umr') {
                    formData[fmkey]['disable'] = false;
                    formData[fmkey]['value'] = null;

                }
                if (fmdata.name === 'mobile') {
                    let value = fmdata['value'];
                    var regex = /^\d{10}$/g;
                    formData[fmkey]['disable'] = false;
                    formData[fmkey]['value'] = null;
                    if (value !== null && value.length > 0 && regex.test(value) === false) {
                        modalShow = false;
                        formData[fmkey]['value'] = value;
                        formData[fmkey]['errors'] = [{ 'message': 'Please Enter valid Mobile Number' }];
                    }
                }
                if (fmdata.name === 'ipnumber') {
                    formData[fmkey]['disable'] = false;
                    formData[fmkey]['value'] = null;
                }
                if (fmdata.name === 'patient_list') {
                    formData[fmkey]['disable'] = false;
                    formData[fmkey]['value'] = null;
                }
            });
            if (modalShow) {
                Modal.error({
                    title: 'Error message',
                    content: 'Please fill any one of the Mandatory fields',

                });
                formData.map((fmdata, fmkey) => {
                    if (fmdata.name === 'patient_list') {
                        formData[fmkey]['disable'] = true;                                
                        formData[fmkey]['value'] = null;
                        delete formData[fmkey]['text']
                        filtereData.map((d, i) => {
                            d['value'] = null;
                            return d;
                        })
                    }
                    if (fmdata['name'] === 'service_type_admission') {
                        formData[fmkey]['disable'] = true;
                        formData[fmkey]['value'] = null;
                        delete formData[fmkey]['text'];
                    }
                    if (fmdata['name'] === 'doctor') {
                        formData[fmkey]['disable'] = true;
                        formData[fmkey]['value'] = null;
                        delete formData[fmkey]['text'];
                    }
                })
            }
            this.setState((state) => ({ 'formData': formData }));
            return false;
        }

    } else {
        this.setState((state) => ({ 'loadding': false }));
    }
}

validateForm(formData) {

    let { billStatus } = this.state;
    let dataNull = false;
    formData.map((data, key) => {
        if (data['element'] === 'select2' || data['element'] === 'input') {
            formData[key]['errors'] = [];
            if (data['name'] === 'payment_status' || data['name'] === 'bill_no') {
                formData[key]['disable'] = true;
            }
            if (data['name'] === 'patient_type' && data['value'] !== 'op' && data['value'] !== 'ip') {
                dataNull = true
            }

            if (dataNull && (data['name'] === 'payment_status' || data['name'] === 'bill_no')) {
                formData[key]['valid'] = false;
                formData[key]['value'] = null;
                billStatus = null;
            }


            data
                .rules
                .map((rule, rkey) => {
                    if (rule.verify !== undefined && typeof rule.verify === 'function') {
                        if (rule.verify(formData)) {
                            formData[key]['disable'] = false;
                        }
                    }
                    if (rule.test !== undefined && typeof rule.test === 'function' && rule.test(data['value'])) {

                        if (billStatus === false && data['name'] === 'bill_no') {
                            formData[key]['errors'].push({ 'message': "Bill Number is Invalid" });
                        } else {
                            formData[key]['errors'] = [];
                        }
                    }
                })
        }
    });

    this.setState((state) => ({ formData: formData }));
}

generateToken() {
    this.setState((state) => ({ 'loadding': true }));
    let obj = {
        "name": null,
        "umr": null,
        "ip": null,
        "gender": null,
        "phone_number": null,
        "privilege_id": null,
        "privilege_name": null,
        "doctor_id": null,
        "payer_type": null,
        "WARDNAME":this.state.wardname?this.state.wardname:null,
        "FLOOR":this.state.floor?this.state.floor:null,
        "BLOCK":this.state.block?this.state.block:null,
        "NURSESTATION_NAME":this.state.nursestation_name?this.state.nursestation_name:null,
    }
    console.clear();
    let { formData, filtereData, payer_type } = this.state
    let errors = [];
    formData.map((data, key) => {
        if (data.rules !== undefined && Array.isArray(data.rules)) {
            formData[key]['errors'] = [];
            if(data.visible){
                data
                .rules
                .map((rule, rkey) => {
                    console.log(rule.test(data['value']), data['value'], data['title']);
                    if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(data['value'])) {
                        formData[key]['errors'].push({ 'message': rule.message });
                        errors.push(false);
                    }
                })
            }
            
        }
    });


    this.setState((state) => ({ 'formData': formData }));

    if (!errors.includes(false)) {
        obj['payer_type'] = payer_type ? payer_type : null
        formData.map((form) => {
            if (form['name'] === 'service_type_admission') {
                obj['privilege_id'] = form.value;
                obj['privilege_name'] = form.text;

            }
            if (form['name'] === 'doctor') {
                obj['doctor_id'] = form.value;
            }
            if (form['name'] === 'counsellor') {
                obj['tg_assigned_counsellor'] = form.value;
            }

        })
        filtereData.map((d, i) => {
            if (d.name === 'name') {
                obj['name'] = d.value;
            }
            if (d.name === 'umr_number') {
                obj['umr'] = d.value;
            }
            if (d.name === 'phonenumber') {
                obj['phone_number'] = d.value;
            }
            if (d.name === 'gender') {
                if (d.value == 'Male') {
                    obj['gender'] = 'male';
                } else {
                    obj['gender'] = 'female';
                }
            }
            if (d.name === 'age') {
                obj['age'] = d.value;
            }
            if (d.name === 'ip') {
                obj['ip'] = d.value;
            }
            if (d.name === 'marital_status') {
                obj['marital_status'] = d.value;
            }
            if (d.name === 'pat_address') {
                obj['pat_address'] = d.value;
            }
            if (d.name === 'is_icu') {
                obj['is_icu'] = d.value;
            }
            

        })
       
        const Userlogobj = {
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "Patient Trackbill Info - Request",
                "date": new Date(),
                "meta": obj
            }
        }
        userTrackService(Userlogobj)
        
        // checking recounselling on tracklist
        if (obj && (obj['umr'] || obj['ip']) && obj['privilege_id'] == 5) {
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            try{
            postService(getPatientTrackbillInfo, 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    "ip_no": obj['ip'] ? obj['ip'] : null,
                    "umr_no": obj['umr'] ? obj['umr'] : null,
                }
            }).then(res => {
                const Userlogobjres = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Patient Trackbill Info - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res.status) {
                    // this.setState((state) => ({ 'loadding': false }));
                    if (res['data'] && res['data'].length > 0) {
                        let data = res['data'][0]['warning_flag']
                        // if(data){
                        this.generateTokenAPI(obj);
                        // }else{
                        //     Modal.info({
                        //         title: `Information`,
                        //         content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                        //         zIndex: '1022'
                        //     });
                        // }
                    } else {
                        this.setState((state) => ({ 'loadding': false }));
                        Modal.info({
                            title: `Information`,
                            content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                            zIndex: '1022'
                        });
                    }
                } else {
                    this.setState((state) => ({ 'loadding': false }));
                    Modal.info({
                        title: `Information`,
                        content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                        zIndex: '1022'
                    });
                }
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
        } else {
            this.generateTokenAPI(obj)
        }
    } else {
        this.setState((state) => ({ 'loadding': false }));
    }

}

getTokensForTG = () => {
    try {
        let { getTokensForTG } = networkList;
        postService(getTokensForTG, 'GET', null).then(res => {
            console.log('getTokensForTG:',res)
            if (res.status) {
              
                this.setState((state) => ({ patientQueue: res.data }));
            }
            else {
                // to catch api errors like --> network,url,outof status 1,0
                Modal.error({
                    title: 'Failure',
                    content: "Oops! something went wrong... Please try again."
                });
            }
        })
    } catch (error) {
        console.log(error);
        Modal.error({
            title: 'Failure',
            content: "Oops, something went wrong... Please try again.",
        });
    }
}

searchClick() {
    i = 0;
    this.setState((state) => ({ 'page_data_count': 1 }), () => {
        this.loadPage();
    })
}


searchChange(e) {
    console.log(e.target.value);
    let value = e.target.value
    i = 0;
    this.setState((state) => ({ 'search': value }), () => {

    });
}
dateRange = () => {
    this.setState((state) => ({
        activePage: 1,
        totalItemsCount: 0,
        page_data_count: 1,
        search_key: '' 
    }), () => {
        this.inputRef.value = null;
        this.loadPage(true);
    })        
}

itemRender(current, type, originalElement) {
    if (type === 'prev') {
        return <a>Previous</a>;
    }
    if (type === 'next') {
        return <a>Next</a>;
    }
    return originalElement;
}

indexIncrement() {
    i = i + 1;
}

pageChange(data) {
    this.setState((state) => ({ 'activePage': data }), () => {
        this.loadPage();
    })
}

downloadFile() {
    i = 0;
    let { getCounsellingsList } = networkList;
    let { page_data_count, search_key,activePage } = this.state;
    this.setState((state) => ({ loadding: true, download_btn: true, downloadStatus: 0  }));
    let This = this;
    try {
        let userData = localStorage.getItem('user_data');
        if(userData !== undefined && userData !== null && userData !== ''){
            userData = JSON.parse(userData);
        }
        let tableHead = [
            {
             'key': 'patient_name',
             'text': 'Patient Name' 
         },
         {
             'key': 'ip_no',
             'text': 'IP number'  
         },
         {
             'key': 'umr_no',
             'text': 'UMR number'  
         },
        
         {
             'key': 'mobile_number',
             'text': 'Phone number'  
         },
         {
             'key': 'vip_status',
             'text': 'VIP Status'
         },
         {
             'key': 'comment',
             'text': 'Remarks' 
         },
         {
             'key': 'created_by',
             'text': 'Requested By' 
         },
         {
             'key': 'created_date',
             'text': 'Requested At'
         },
         ];

            This.setState((state) => ({ downloadStatus: 0, thead: tableHead, filename: 'vip-tag.csv', download_btn: true, loadding: true }), () => {
                postService('getPatientVipStatus', 'POST',
               { "data": {
                    "search_key": this.state.search ? this.state.search : "",
                    "export": 1, //1 for download excel
                    "page_no": activePage,
                    "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                    "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                }}
                ).then(res => {
                    console.log('tat report:', res.data);
                    if (res.status) {
                        // if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                        //     let newArray = [];
                        //     res['data'].map((row, rkey) => {
                        //         row['s_no'] = rkey;
                        //         if (row['data'] && Array.isArray(row['data']) && row['data'].length !== 0) {
                        //             if (row['data'].length === 1) {
                        //                 row['data'][0]['haschild'] = false;
                        //                 row['data'][0]['s_no'] = rkey;
                        //                 row['data'][0]['date'] = row['date'];
                        //                 newArray.push(row['data'][0]);
                        //             } else {
                        //                 row['haschild'] = true;
                        //                 newArray.push(row);
                        //                 row['data'].map((subrow, skey) => {
                        //                     subrow['child'] = true;
                        //                     subrow['parrent_id'] = `collapse_${row['admissions_id']}`;
                        //                     newArray.push(subrow);
                        //                 })
                        //             }
                        //         } else {
                        //             row['s_no'] = rkey;
                        //             row['haschild'] = false;
                        //             newArray.push(row);
                        //         }
                        //     })
                        //     console.clear();
   
                        //     console.log(newArray);
                        //     let downloadtablebody =[]
                        //     if(newArray && newArray.length !== 0)
                        //         {
                        //             newArray.map((data, key) => {
                        //                 if (data['haschild'] === false) {
                        //                     downloadtablebody.push(data);                                            
                        //                 }
                        //                 if ((data['haschild'])) {
                        //                     // downloadtablebody.push(data);
                        //                     data['data'].map((subrow, skey) => {
                        //                         downloadtablebody.push(subrow);                                                                                                       
                        //                     })
                        //                 }                                        
                        //         })
                        //     }
                        //     This.setState((state) => ({ downloadStatus: 1, downloadtbody: downloadtablebody ? downloadtablebody : [], loadding: false }));
                        //     this.csvLink.current.link.click();
                        // }
                        if (res.status) {
                            if (res.data && res.data.admissions_data) {
                                res.data.admissions_data.map((data, key) => {
                                    Object.keys(data).map((dataKey) => {
                                        res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? res.data.admissions_data[key][dataKey] : 'NA'
                                    })
                                })
                            }
                            This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                            this.csvLink.current.link.click();
                        } else {
                            if (res === 401) {

                            } else {
                                Modal.error({
                                    title: 'Failure',
                                    content: "Oops! something went wrong... Please try again.",
                                });
                            }
                        }
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });

    } catch (error) {
        this.setState((state) => ({ loadding: false }));
    }
}
  render() {
    let { tableTitle,thead,tbody,formData, loadding, add_discount_form, onCancel, discountrequestaddformData, remarks, patient_willing,activePage,total_items,page_length,download_btn,downloadStatus,responseData,downloadtbody,downloadthead,filename} = this.state;
    return (
      <div >
         {
                    download_btn
                        ?
                        downloadStatus && responseData != ''
                            ?
                            <div className="row mb-2 ml-5 mr-5 download sticky-top d-flex flex-row-reverse">
                                <button className="btn btn-success text-capitalize mr-3" style={{backgroundColor:'#218838'}} onClick={() => { this.addDiscountForm() }}><span> Add</span></button>
                                <button className="btn btn-success text-capitalize float-left mr-3" onClick={()=>{this.downloadFile()}}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Report</span></button>
                                <CSVLink data={downloadtbody} headers={downloadthead} filename={filename} className="hidden" ref={this.csvLink} />
                            </div>
                            :
                            <div className="row mb-2 ml-5 mr-5 download sticky-top d-flex flex-row-reverse">
                                <button className="btn btn-success text-capitalize mr-3" style={{backgroundColor:'#218838'}} onClick={() => { this.addDiscountForm() }}><span> Add</span></button>
                                <Button className="btn btn-success-disabled text-capitalize float-left mr-3" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Report</span></Button>
                            </div>
                        :
                        <div className="mt-5" />
                }
      {/* <div className="clearfix mx-5" >

                            <div className="float-right mb-2">
                                
                                {/* <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined className="align-middle pr-2" /><span> Clear</span></button>
                                <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></button> */}
                            {/* </div> */}
                           
      {/* </div> */} 
      <Modal
            width='46%'
            visible={add_discount_form}
            onCancel={onCancel}
            destroyOnClose={true}
            footer={null}
            maskClosable={false}
          >
            <Spin spinning={this.state.loadding}>
                                     <div  style={{padding:'0px',width:'106%'}}>
                                     <h3 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>Tag/UnTag VIP Status</h3>
                                    <div className="row pt-4 justify-content-center discount-request">
                                    {(discountrequestaddformData !== undefined) && (
                                            <React.Fragment>
                                            {discountrequestaddformData.map((feild, key) => {
                                                if (feild.element === 'input') {
                                                    return (
                                                        <div  className={`${feild.className
                                                            ? feild.className
                                                            : 'col'} my-2 ${feild.name}`} style={{padding:'10px'}}> 
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col'} my-2 ${feild.name}`} style={{marginLeft:'-52px', width:'100px'}}
                                                            key={key}>
                                                            <label className="data-label w-100" style={{marginLeft:'11px'}}>{feild.title}</label>
                                                            <div style={{width:'140px', marginLeft:'12px'}}>
                                                            <Inputlayer
                                                                {...this.props}
                                                                {...this.state}
                                                                feildData={feild}
                                                                onInputChanges={this.formonChange.bind(this)}
                                                            />
                                                            </div>
                                                            
                                                        </div>
                                                        </div>
                                                    );
                                                }
                                                if (feild.element === 'button') {
                                                    return (
                                                        <div key={key} className="row" style={{marginTop:'40px',marginLeft:'-15px'}}>
                                                            <div className={`col my-2 ${feild.name}`}>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-block"
                                                                    onClick={this.SearchEvent.bind(this)}
                                                                >
                                                                    {feild.text}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                style={{width:'98%', marginLeft:'-5%'}}
                                                                className={`col-12 my-2 ${feild.name}`}
                                                                key={key} >
                                                                     {(feild.name === 'patient_list') &&
                                                    <div className="col-6 pl-0">
                                                        <p className="mb-0 text-black" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="data-label" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Select Patient</p>
                                                    </div>}
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .formonChange
                                                                        .bind(this)}
                                                                /> 
                                                                {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                            })}
                                            
   <div
                                                                className={`col-12 my-2`}
                                                            >
                                                                <textarea placeholder="Add Comments" autoFocus='true' className="textarea" style={{ height: '90px', width:'%', marginLeft:'-3%', marginTop:'0%'}} 
                                                                    value={remarks ? remarks  : ''} 
                                                                    onChange={(event) => this.handleChangeRemarks(event)}>
                                                                </textarea>
                                                                {/* {feild
                                                                .errors
                                                                .map((error, eKey) => {
                                                                    return (
                                                                        <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                    );
                                                                })} */}
                                                            </div>
                                        {/* <div style={{marginLeft:'0px'}}>
                                                            <div style={{ display: 'flex', alignItems: 'center', marginLeft:'-218%'}}>
                                                             <input type="checkbox" onChange={this.handleCheckboxChange} />
                                                             <span style={{ fontFamily: 'normal', fontSize: '15px', marginLeft: '5px' }}>Is Patient Dead</span>
                                                                   </div>
                                                                   </div> */}

                                            </React.Fragment>
                                        )}
                                    </div>
                                    
                                    <div style={{marginLeft:'150px'}}>
                                            <button style={{marginTop: '25px'}} className="btn btn-success text-capitalize mr-3" onClick={this.addDiscountRequest} disabled={this.state.btnloading || this.state.saveClicked}>save</button>
                                            <button style={{marginTop: '25px'}} className="btn btn-next text-capitalize" onClick={this.discountAddHandleCancel} loading={this.state.btnloading}>cancel</button>
                                        </div>
                                     </div>
            </Spin>
          </Modal>
          
      <Spin spinning={loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                            <div className="float-left pt-1">
                            Tag-Untag-Vip
                            </div>
                                <div className="row">
                                {formDataSchema.feilds
                                    .map((feild, key) => {

                                        if (feild.element === 'input' && feild.visible) {
                                            return (                                                
                                            <div className="col-6 mx-auto">
                                                <div class="input-group">
                                                    {/* <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" onBlur={this.searchChange.bind(this)} ref={(inputRef =>(this.inputRef = inputRef))} />
                                                    <div class="input-group-append">
                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                    </div> */}
                                                </div>
                                            </div>
                                            )
                                        }
                                        if (feild.element === 'daterange') {
                                            return (
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col '} ${feild.name}`}
                                                    key={key}>
                                                    {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}
                                                    
                                                    {/* <DateRange
                                                        Queuedata={formData}
                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] });  }}
                                                    />
                                                    <div class="input-group-append">                                                                           
                                                        <button class="btn btn-primary btn-sm ml-1" onClick={()=>{this.dateRange()}}>Go</button>
                                                    </div> */}
                                                    {/* ,()=>this.renderBody() */}
                                                </div>
                                            )
                                        }
                                        // if (feild.element === 'select2' && feild.visible) {
                                        //     return (
                                        //         <React.Fragment key={key}>
                                        //             {(feild.name === 'patient_list' && feild.disable === false) &&
                                        //                 <div className="col-6">
                                        //                     <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                        //                 </div>}
                                        //             <div
                                        //                 className={`${feild.className
                                        //                     ? feild.className
                                        //                     : 'col '} ${feild.name}`}
                                        //                 key={key}>
                                        //                 <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text2}</p>
                                        //                 <Select2
                                        //                     Queuedata={formData}
                                        //                     selectdata={feild}
                                        //                     {...this.props}
                                        //                     {...this.state}
                                        //                 /> {feild
                                        //                     .errors
                                        //                     .map((error, eKey) => {
                                        //                         return (
                                        //                             <small key={eKey} className="form-text text-danger">{error.message}</small>
                                        //                         );
                                        //                     })}
                                        //             </div>
                                        //         </React.Fragment>
                                        //     )
                                        // }
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="financial-table table-responsive sticky-header" id="table">
                            <table className="table table-hover table-bordered mb-0 track-bills bg-white">
                            <thead>
                                <tr>
                                    <td>S.no</td>
                                    {thead.map((head, key) => {
                                        return (<td key={key}>{head.text}</td>);
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {tbody.map((body, key) => {
                                    console.log('TAbleData', body);
                                    return (<tr key={key}>
                                        {/* onClick={this.navigateTo.bind(this,body)} style={{cursor: 'pointer'}} */}
                                        <td>{(key + 1) + ( activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                        {thead.map((head, Hkey) => {
                                               if (head['key'] === 'requested_at' || head['key'] === 'approved_date') {
                                                    return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm') : 'NA'}</td>)
                                                }else{
                                                    return ( <td className="text-capitalize">
                                                    {(body[head['key']] !== null && body[head['key']] !== "") ? body[head['key']] : 'NA'}
                                              </td>)
                                                }

                                        })
                                        }

                                    </tr>)
                                })}
                                {(tbody && tbody.length === 0) && <React.Fragment>

                                    <tr>
                                        <td colSpan={thead.length + 1} className="text-center">
                                            {/* <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" /> */}
                                            <p className="no-data mb-0">No Data</p>
                                        </td>
                                    </tr>

                                </React.Fragment>}
                            </tbody>
                            </table>
                        </div>

                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                        <Pagination current={activePage} total={total_items} itemRender={this.itemRender.bind(this)} pageSize={page_length} showSizeChanger={false} onChange={this.pageChange.bind(this)} />
                        </div>
                    </div>
      </Spin>
      </div>
    );
  }
}

export default TagVip;